import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationService } from '@/services/notification.service';
import { testimonialService } from '@/services/testimonial.service';
import { TestimonialError } from '@/exceptions/testimonial/testimonial.enum';


const useCreateTestimonial = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (testimonial: FormData) =>
            await testimonialService.newTestimonial(testimonial),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['testimonial'] });
            notificationService.success("Testimonial Created Succesful");

        },

        onError: () => {
            throw new Error(TestimonialError.CREATE_ERROR);
        },
    });
};

export default useCreateTestimonial;
